import { ApiError } from "./api.error";
export class AuthorizationError extends Error {
  apiError?: ApiError | undefined;
  constructor(
    error: any | null,
    message: string = "",
    apiError?: ApiError | undefined
  ) {
    super(message);
    this.apiError = apiError;
  }
}
